import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { ValidationObserver } from 'vee-validate';
import PInputText from 'primevue/inputtext';
import IconArrowDown from '~/components/general/icons/IconArrowDown.vue';
import CloseCircle from '~/components/common/icons/CloseCircle.vue';
import { PAYMENT_TYPES } from '~/utils/utils';
import { convertDateToDisplay } from '~/utils/date-time';

/** A ticket config in the selection list, with the sale-window flags the event page computes. */

/**
 * A ticket config as held in the cart. The event page enriches it with the
 * selected discount, seat, occurrence and timeslot — see `adjustTicketDataForCart`
 * in pages/_tenant/event/_id/index.vue. `sector` narrows from the config's list
 * to the single selected sector, hence the Omit.
 */

/** A cart ticket plus this component's per-row expand toggle. */

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketPricePreview',
  props: {
    ticketConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tickets: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currency: {
      type: String,
      default: ''
    },
    timezoneName: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: null
    },
    market: {
      type: String,
      default: 'primary'
    },
    selectionValid: {
      type: Boolean,
      default: false
    },
    discountCodeValue: {
      type: String,
      default: null
    },
    eventInPresale: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'remove'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var notifier = useNotifier();
    var whitelabel = useWhitelabel();
    var _useI18n = useI18n(),
      t = _useI18n.t,
      d = _useI18n.d;
    var _useBreakpoint = useBreakpoint(),
      xsOnly = _useBreakpoint.xsOnly,
      mdAndDown = _useBreakpoint.mdAndDown;
    var observer = ref();
    var expand = ref(false);
    var discountCode = ref(props.discountCodeValue);
    var accessCode = ref(null);
    var selectedTickets = ref(props.tickets.map(function (ticket) {
      return _objectSpread(_objectSpread({}, ticket), {}, {
        expanded: false
      });
    }));
    var isSmallDevice = mdAndDown;
    var isMobile = xsOnly;
    var isSmallDeviceNotMobile = computed(function () {
      return isSmallDevice.value && !isMobile.value;
    });
    var ticketNumber = computed(function () {
      return selectedTickets.value.length;
    });
    var buyIsDisabled = computed(function () {
      return ticketNumber.value === 0 || !props.selectionValid;
    });
    var ticketsAreAvailable = computed(function () {
      return props.ticketConfig.some(function (tc) {
        return tc.availableTickets > 0 && tc.quantity > 0 && !tc.ended && tc.started;
      });
    });
    var ticketCost = computed(function () {
      return selectedTickets.value.reduce(function (result, ticket) {
        var net = Number(ticketPrice(ticket)) + Number(result.net);
        var isCrypto = whitelabel.supportedCryptoCurrencies.includes(props.currency.toUpperCase());
        return {
          net: net.toFixed(isCrypto ? 8 : 2),
          fees: result.fees + ticket.fees
        };
      }, {
        net: '0',
        fees: 0
      });
    });

    // The cart mutates this array in place (push/splice), so its identity rarely
    // changes. Vue 2.7's composition `watch` only invokes the callback when the
    // source's identity changes -- unlike the Options API watcher this replaced --
    // so copy the array to give the watcher a fresh reference on every notification.
    watch(function () {
      return _toConsumableArray(props.tickets);
    }, function (newValue) {
      if (newValue) {
        selectedTickets.value = newValue.map(function (ticket) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            expanded: false
          });
        });
      }
    });
    function ticketHasAdditionalDetails(ticket) {
      return !!(ticket.seat || ticket.discount || isRecurringOrHasTimeslots(ticket) || isDonation(ticket.pricingType));
    }
    function toggleTicketDetails(ticket) {
      ticket.expanded = !ticket.expanded;
    }
    function isRecurringOrHasTimeslots(ticket) {
      return !!(ticket.occurrenceName || ticket.timeslotName);
    }
    function startDate(ticket) {
      var eventStartDate;
      if (ticket.timeslotStartAt) {
        eventStartDate = ticket.timeslotStartAt;
      } else if (ticket.occurrenceStartAt) {
        eventStartDate = ticket.occurrenceStartAt;
      }
      var startDate = convertDateToDisplay(eventStartDate, props.timezoneName);
      return {
        date: d(startDate, 'DD_MM_YYYY'),
        time: d(startDate, 'HH_mm')
      };
    }
    function endDate(ticket) {
      var eventEndDate;
      if (ticket.timeslotEndAt) {
        eventEndDate = ticket.timeslotEndAt;
      } else if (ticket.occurrenceEndAt) {
        eventEndDate = ticket.occurrenceEndAt;
      }
      var endDate = convertDateToDisplay(eventEndDate, props.timezoneName);
      return {
        date: d(endDate, 'DD_MM_YYYY'),
        time: d(endDate, 'HH_mm')
      };
    }
    function onSameDay(ticket) {
      return startDate(ticket).date === endDate(ticket).date;
    }
    function isDonation(pricingType) {
      return pricingType === PAYMENT_TYPES.DONATION;
    }
    function ticketPrice(ticket) {
      if (isDonation(ticket.pricingType)) {
        return ticket.donationAmount;
      }
      return ticket.finalPrice;
    }
    function onHeaderClick() {
      if (ticketNumber.value !== 0) {
        expand.value = !expand.value;
      }
    }
    function onBuyClick() {
      if (ticketNumber.value === 0 && ticketsAreAvailable.value) {
        notifier.showMessage({
          content: t('errors.emptyCart'),
          type: 'warning'
        });
      }
    }
    function handleBuyClick() {
      return _handleBuyClick.apply(this, arguments);
    }
    function _handleBuyClick() {
      _handleBuyClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var accessCodeValid;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!props.eventInPresale) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return observer.value.validate();
            case 1:
              accessCodeValid = _context.sent;
              if (accessCodeValid) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              emit('submit', discountCode.value, accessCode.value);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleBuyClick.apply(this, arguments);
    }
    function expandEnter(el) {
      el.style.height = '0';
      // Reading layout forces a reflow, so the transition starts from zero
      el.getBoundingClientRect();
      el.style.height = "".concat(el.scrollHeight, "px");
    }
    function expandAfterEnter(el) {
      el.style.height = '';
    }
    function expandLeave(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
      el.getBoundingClientRect();
      el.style.height = '0';
    }
    function expandAfterLeave(el) {
      el.style.height = '';
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      notifier: notifier,
      whitelabel: whitelabel,
      t: t,
      d: d,
      xsOnly: xsOnly,
      mdAndDown: mdAndDown,
      observer: observer,
      expand: expand,
      discountCode: discountCode,
      accessCode: accessCode,
      selectedTickets: selectedTickets,
      isSmallDevice: isSmallDevice,
      isMobile: isMobile,
      isSmallDeviceNotMobile: isSmallDeviceNotMobile,
      ticketNumber: ticketNumber,
      buyIsDisabled: buyIsDisabled,
      ticketsAreAvailable: ticketsAreAvailable,
      ticketCost: ticketCost,
      ticketHasAdditionalDetails: ticketHasAdditionalDetails,
      toggleTicketDetails: toggleTicketDetails,
      isRecurringOrHasTimeslots: isRecurringOrHasTimeslots,
      startDate: startDate,
      endDate: endDate,
      onSameDay: onSameDay,
      isDonation: isDonation,
      ticketPrice: ticketPrice,
      onHeaderClick: onHeaderClick,
      onBuyClick: onBuyClick,
      handleBuyClick: handleBuyClick,
      expandEnter: expandEnter,
      expandAfterEnter: expandAfterEnter,
      expandLeave: expandLeave,
      expandAfterLeave: expandAfterLeave,
      ValidationObserver: ValidationObserver,
      PInputText: PInputText,
      IconArrowDown: IconArrowDown,
      CloseCircle: CloseCircle
    };
  }
});